//
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import ProviderAccountBankModel from '@/models/Purchase/PchProviderAccountBank'
import UserModel from '@/models/General/GUser'

//
import DetailProviderPaymentSheetHeaders from '@/views/Purchase/PchProviderPaymentSheet/partials/DetailProviderPaymentSheetHeaders'

//
import PurchaseInvoiceFilters from '@/views/Purchase/PchPurchaseInvoice/partials/PurchaseInvoiceFilters'
import PurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/partials/PurchaseInvoiceHeaders'

//
export default ({ payment_date, can_update, export_name }) => [
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noObject: true,
            readonly: true,
        },
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Fecha de pago',
        },
    },
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'hr_employee_full_name',
            itemValue: 'id',
            label: 'Supervisor',
            model: UserModel,
            noObject: true,
            readonly: true,
        },
    },
    {
        name: 'state_name',
        type: 'text-field',
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'd-grid': true,
            xs12: true,
        },
        props: {
            alwaysExport: true,
            headers: DetailProviderPaymentSheetHeaders,
            noDataText: 'Sin documentos por pagar.',
            noExport: false,
            exportName: export_name,
            pickerProps: {
                filters: PurchaseInvoiceFilters,
                headers: PurchaseInvoiceHeaders,
                noDataText: 'Sin documentos pagables pendientes.',
                initialFilterValues: {
                    payment_date,
                },
                paramFilter: {
                    payable: true,
                    not_in_payment_sheet: true,
                },
                paramSearch: 'invoice_number',
                service: PurchaseInvoiceModel,
                title: 'Seleccionar documento a pagar',
            },
            toolbarTitle: 'Listado de facturas',
            readonly: !can_update,
            showPicker: true,
        },
        trigger(ctx) {
            ctx.value.selected.forEach(e => {
                if (!e.pch_provider_account_bank_id) {
                    // getting account bank
                    ProviderAccountBankModel.modeler()
                        .where('pch_provider_id', e.pch_provider_id)
                        .get()
                        .then(({ data }) => {
                            e.pch_provider_account_bank = data.slice().pop()
                            console.log()
                            ctx.$refs.fieldset.$forceUpdate()
                        })

                    // setting waiting account bank
                    e.pch_provider_account_bank = {
                        id: 1,
                        account_number: 'Cargando cuenta...',
                        g_bank: {
                            bank: 'Cargando cuenta...',
                        },
                    }
                }
            })
        },
    },
    {
        name: 'selected_total',
        type: 'currency-field',
        props: {
            label: 'Total',
            readonly: true,
            reverse: true,
        },
    },
]
